import { GET_POPULAR_MARKET_IDS_SUCCESS,
  GET_POPULAR_MARKET_IDS_REQUEST,
  GET_POPULAR_MARKET_IDS_FAILURE,
} from 'Store/constants';
  
const initialState = {
  data: {},
  isLoading: null,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_POPULAR_MARKET_IDS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_POPULAR_MARKET_IDS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_POPULAR_MARKET_IDS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
  